// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__263W9","badges":"styles_badges__gF-F1"};